<template>
  <div class="footer-journals-family">
    <div class="row mb-2">
      <div class="col-12">
        <p class="pt-3 pr-3 d-inline-block">
          Visit the Rapamycin Family of <br /> Medical Science Journals
        </p>
        <img :src="getStaticPath(rapamycinLogo)" class="float-right" alt="Rapamycin Logo" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-nav vertical>
          <!--TODO:  Add site links  -->
          <template v-for="site in sortedList">
            <b-nav-item>{{site.name}}</b-nav-item>
          </template>
        </b-nav>
      </div>
    </div>
  </div>
</template>
<script>
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'

  export default {
    name: 'footer-journals-family',
    mixins: [ UtilityMixin ],
    data () {
      return {
        rapamycinLogo: 'img/rapamycin-logo.png',
        siteName: process.env.SITE_NAME,
        sitesList: [
          {name: 'Oncotarget'},
          {name: 'Oncoscience'},
          {name: 'Aging'},
          {name: 'Genes & Cancer'}
        ]
      }
    },
    computed: {
      sortedList () {
        // Sort list to show active site link on the first place
        let indexOfFirestItem = 0
        let result = this.sitesList.slice()
        let firstItem = this.sitesList.find((item, index) => {
          if (item.name === this.siteName) {
            indexOfFirestItem = index
            return true
          } else {
            return false
          }
        })
        result.splice(indexOfFirestItem, 1)
        result.unshift(firstItem)
        return result
      }
    }
  }
</script>
<style lang="scss">
  .footer-journals-family{
    font-family: 'Open Sans Condensed', sans-serif;
    font-size: 18px;
    line-height: 1.21;
    text-align: end;
    .nav-item  {
    a {
      padding: 0px;
      line-height: 24px;
      text-decoration: underline;
      &:hover, &:active, &:focus {
                          text-decoration: underline;
                        }
      }
    &:first-child {
      a {
        text-decoration: none;
        cursor: default;
        font-weight: 600;
        color: $primary-color;
        }
      }
    }
  }
  @media (max-width: $breakpoint-md) {
    .footer-journals-family {
      text-align: start;
    }
  }
</style>



// WEBPACK FOOTER //
// FooterJournalsFamilyComponent.vue?f92514b8